import {
  UserApi,
  OrderApi,
  PhotoSizeApi,
  AuthApi,
  CouponsApi,
  PhotosApi,
  ProductApi,
  OrderProductDetailApi,
  ProductTagApi,
  BannerMessageApi,
  PricingApi,
  AnalyticsApi,
  InvoicesApi,
  CreditAdminApi,
  CreditApi,
  CreditNotesApi,
  EmailCampaignsApi,
  MetaConversionsApi,
  EmailTemplateApi,
  EmailLogApi,
  EmailRuleApi,
  PostApi,
  ProductWithMediaDefinitionApi,
  ProductWithMediaVariantApi,
  ArtworkApi,
  ArtworkCollectionApi,
  ProductWithMediaOrderApi,
  PaperApi,
  ElementImageApi,
  TemplateApi,
  GiftCardApi,
  GiftCardAdminApi,
} from "./generated-api";
import axios from "axios";
import { Configuration } from "./generated-api/configuration";
import axiosInstance from "src/axios";
import nookies from "nookies";
import { ORDER_SESSION_COOKIE_MAX_AGE_SECONDS } from "src/utils/order-freshness";

const config = new Configuration();
// const axiosInstance = axios.create();

const setBearerToken = (token?: string) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    axiosInstance.defaults.headers.common["Authorization"] = false;
  }
};

const setGuestTokenCookies = (token?: string) => {
  if (token) {
    // path:"/" is essential — without it the cookie is scoped to the directory
    // it was set in (e.g. /sl/design/...), so the guest token is invisible on
    // other pages (home, checkout) and the cart can't be fetched there.
    // Lifetime derived from CART_MAX_AGE_DAYS, never a literal: this was pinned
    // at 47h, so a cart the age policy allowed to live 5 days lost the token
    // that proves ownership of it after two.
    nookies.set(null, "guest_token", token, {
      maxAge: ORDER_SESSION_COOKIE_MAX_AGE_SECONDS,
      path: "/",
    });
    axiosInstance.defaults.headers.common["x-guest-token"] = token;
  } else {
    nookies.set(null, "guest_token", "", {
      maxAge: 0,
      path: "/",
    });
    axiosInstance.defaults.headers.common["x-guest-token"] = false;
  }
};

const getGuestTokenCookies = () => {
  if (nookies.get(null).guest_token) {
    return nookies.get(null).guest_token;
  }
  return undefined;
};

// Export configuration for other services
export const getConfiguration = () => config;

export const BASE_API_URL = process.env.NEXT_PUBLIC_BASE_URL;
const userApi = new UserApi(config, BASE_API_URL, axiosInstance);
const orderApi = new OrderApi(config, BASE_API_URL, axiosInstance);
const photoSizeApi = new PhotoSizeApi(config, BASE_API_URL, axiosInstance);
const authApi = new AuthApi(config, BASE_API_URL, axiosInstance);
const couponsApi = new CouponsApi(config, BASE_API_URL, axiosInstance);
const photosApi = new PhotosApi(config, BASE_API_URL, axiosInstance);
const productTagApi = new ProductTagApi(config, BASE_API_URL, axiosInstance);
const productApi = new ProductApi(config, BASE_API_URL, axiosInstance);
const pricingApi = new PricingApi(config, BASE_API_URL, axiosInstance);
const analyticsApi = new AnalyticsApi(config, BASE_API_URL, axiosInstance);
const invoicesApi = new InvoicesApi(config, BASE_API_URL, axiosInstance);
const creditNotesApi = new CreditNotesApi(config, BASE_API_URL, axiosInstance);
const creditApi = new CreditApi(config, BASE_API_URL, axiosInstance);
const creditAdminApi = new CreditAdminApi(config, BASE_API_URL, axiosInstance);
const bannerMessageApi = new BannerMessageApi(
  config,
  BASE_API_URL,
  axiosInstance
);
const orderProductDetailApi = new OrderProductDetailApi(
  config,
  BASE_API_URL,
  axiosInstance
);
const emailCampaignsApi = new EmailCampaignsApi(
  config,
  BASE_API_URL,
  axiosInstance
);
const metaConversionsApi = new MetaConversionsApi(
  config,
  BASE_API_URL,
  axiosInstance
);
const emailTemplateApi = new EmailTemplateApi(config, BASE_API_URL, axiosInstance);
const emailLogApi = new EmailLogApi(config, BASE_API_URL, axiosInstance);
const emailRuleApi = new EmailRuleApi(config, BASE_API_URL, axiosInstance);
const postApi = new PostApi(config, BASE_API_URL, axiosInstance);
const productWithMediaDefinitionApi = new ProductWithMediaDefinitionApi(config, BASE_API_URL, axiosInstance);
const productWithMediaOrderApi = new ProductWithMediaOrderApi(config, BASE_API_URL, axiosInstance);
const productWithMediaVariantApi = new ProductWithMediaVariantApi(config, BASE_API_URL, axiosInstance);
const artworkApi = new ArtworkApi(config, BASE_API_URL, axiosInstance);
const artworkCollectionApi = new ArtworkCollectionApi(config, BASE_API_URL, axiosInstance);
const paperApi = new PaperApi(config, BASE_API_URL, axiosInstance);
export const elementImageApi = new ElementImageApi(config, BASE_API_URL, axiosInstance);
export const templateApi = new TemplateApi(config, BASE_API_URL, axiosInstance);
export const giftCardApi = new GiftCardApi(config, BASE_API_URL, axiosInstance);
export const giftCardAdminApi = new GiftCardAdminApi(config, BASE_API_URL, axiosInstance);
export {
  userApi,
  orderApi,
  photoSizeApi,
  authApi,
  couponsApi,
  photosApi,
  productApi,
  productTagApi,
  orderProductDetailApi,
  bannerMessageApi,
  pricingApi,
  analyticsApi,
  invoicesApi,
  creditAdminApi,
  creditApi,
  creditNotesApi,
  emailCampaignsApi,
  metaConversionsApi,
  emailTemplateApi,
  emailLogApi,
  emailRuleApi,
  postApi,
  productWithMediaDefinitionApi,
  productWithMediaVariantApi,
  artworkApi,
  artworkCollectionApi,
  productWithMediaOrderApi,
  paperApi,
  axiosInstance,
  setBearerToken,
  setGuestTokenCookies,
  getGuestTokenCookies,
};
